import { businessErrorFactory, BusinessError } from '../../../../../common/business-error';

import { BUSINESS_ERRORS } from './interfaces';

const APP_ID_ALREADY_EXISTS_IN_YOUR_APPS =
  'USSD App with given id already exists in your Apps. Please try again with different id.';

const APP_ID_ALREADY_EXISTS_IN_OTHER_DEVELOPER_APPS =
  'USSD App with given id already exists in other developers Apps. Please try again with different id.';

const APP_INVALID_URL = 'USSD App with given URL has invalid format. Please try again with different URL.';

const CREATED_APPS_LIMIT_REACHED =
  // eslint-disable-next-line max-len
  "You reached limit of available USSD App. You can't create a new one. If you want to increase your limit, contact with support.";

const CREATE_APP_UNEXPECTED_ERROR =
  'Sorry your App could not be created. Please try again. If the problem still persists, contact with support.';

const EDIT_APP_NOT_FOUND =
  // eslint-disable-next-line max-len
  'USSD App with given id not exists. Please refresh the page and try again. If the problem still persists, contact with support.';

const EDIT_APP_UNEXPECTED_ERROR =
  'Sorry your App could not be edited. Please try again. If the problem still persists, contact with support.';

export const getCreateAppBusinessError = (businessError: BUSINESS_ERRORS): BusinessError => {
  switch (businessError) {
    case BUSINESS_ERRORS.APP_ID_ALREADY_EXISTS_IN_YOUR_APPS: {
      return businessErrorFactory({
        message: APP_ID_ALREADY_EXISTS_IN_YOUR_APPS,
        severity: 'warning'
      });
    }
    case BUSINESS_ERRORS.APP_ID_ALREADY_EXISTS_IN_OTHER_DEVELOPER_APPS: {
      return businessErrorFactory({
        message: APP_ID_ALREADY_EXISTS_IN_OTHER_DEVELOPER_APPS,
        severity: 'warning'
      });
    }
    case BUSINESS_ERRORS.APP_INVALID_URL: {
      return businessErrorFactory({
        message: APP_INVALID_URL,
        severity: 'warning'
      });
    }
    case BUSINESS_ERRORS.CREATED_APPS_LIMIT_REACHED: {
      return businessErrorFactory({
        message: CREATED_APPS_LIMIT_REACHED,
        severity: 'warning'
      });
    }
    default: {
      return businessErrorFactory({
        message: CREATE_APP_UNEXPECTED_ERROR,
        severity: 'error'
      });
    }
  }
};

export const getEditAppBusinessError = (businessError: BUSINESS_ERRORS): BusinessError => {
  switch (businessError) {
    case BUSINESS_ERRORS.APP_INVALID_URL: {
      return businessErrorFactory({ message: APP_INVALID_URL, severity: 'warning' });
    }
    case BUSINESS_ERRORS.APP_NOT_FOUND: {
      return businessErrorFactory({ message: EDIT_APP_NOT_FOUND, severity: 'warning' });
    }
    default: {
      return businessErrorFactory({ message: EDIT_APP_UNEXPECTED_ERROR, severity: 'error' });
    }
  }
};
